import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck } from 'lucide-react';
export function Guarantee() {
  return <section className="py-8 md:py-16 px-4 bg-navy-900 text-white" data-id="element-89">
      <div className="max-w-4xl mx-auto bg-navy-800 border border-navy-700 rounded-3xl p-8 md:p-12 text-center relative overflow-hidden" data-id="element-90">
        {/* Decorative background element */}
        <div className="absolute top-0 left-0 w-full h-2 bg-gradient-to-r from-gold via-yellow-200 to-gold" data-id="element-91"></div>

        <motion.div initial={{
        scale: 0.8,
        opacity: 0
      }} whileInView={{
        scale: 1,
        opacity: 1
      }} viewport={{
        once: true
      }} className="flex justify-center mb-6" data-id="element-92">
          <div className="bg-green-500/20 p-4 rounded-full" data-id="element-93">
            <ShieldCheck size={64} className="text-green-400" data-id="element-94" />
          </div>
        </motion.div>

        <h2 className="font-display text-4xl md:text-5xl text-white uppercase tracking-wide mb-6" data-id="element-95">
          GARANTÍA FUERZA MAYOR — 7 DÍAS
        </h2>

        <p className="text-xl text-navy-100 mb-8 max-w-2xl mx-auto leading-relaxed" data-id="element-96">
          Abrís los 6 tomos. Revisás los 6 bonos. Los usás en tu clase si
          querés. Si en 7 días no es lo que esperabas:{' '}
          <strong className="text-gold" data-id="element-97">
            Te devolvemos el 100%. Sin preguntas. Sin formularios. Sin drama.
          </strong>
        </p>

        <p className="text-navy-300 max-w-3xl mx-auto" data-id="element-98">
          La confianza que tenemos en FUERZA MAYOR nos permite hacer esa promesa
          sin dudar. Más de 500 profes y kinesiólogos de todo el país ya lo
          saben. La tasa de devoluciones es menor al 1%.
        </p>
      </div>
    </section>;
}